import { Input } from '@/components/Input';
import { selectAbnActiveFrom } from '@/context/borrower';
import { useAppSelector } from '@/context/storeHooks';
import { formatDatetoString } from '@/utils/formatDatetoString';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'AbnActiveFrom';

export function AbnActiveFrom({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectAbnActiveFrom);

    // ***** Helper Functions *****
    const formatDateString = (dateString: string | undefined): string => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString; // Return original if invalid
            return formatDatetoString(date);
        } catch {
            return dateString; // Return original if parsing fails
        }
    };

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title='Active from'
                placeholder={currentState || '11-11-2011'}
                showErrors={showErrors && !currentState}
                id={`${baseId}-input-abnActiveFrom`}
                value={formatDateString(currentState)}
                disabled
                tooltipContent='We collect this automatically using your ABN.'
            />
        </div>
    );
}
